export default __webpack_public_path__ + "static/media/sacolaVazia.358abaf9.svg";